import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

interface StackedBarsChartProps {
  series: ApexAxisChartSeries;
  height?: string | number;
  colors?: string[];
  categories: string[];
  stackType?: boolean;
}

const StackedBarsChart: React.FC<StackedBarsChartProps> = ({
  series,
  height,
  colors,
  categories,
  stackType = true,
}) => {
  const [key, setKey] = useState(0);

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      stacked: true,
      stackType: stackType ? "100%" : "normal",
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    colors: colors,
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      categories: categories,
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      offsetX: 40,
    },
    yaxis: {
      labels: {
        formatter: (val) =>
          stackType ? `${val.toFixed(0)}%` : `${Math.round(val)}`,
      },
    },
    tooltip: {
      y: {
        formatter: (val) =>
          stackType ? `${val.toFixed(0)}` : `${Math.round(val)}`,
      },
    },
  };


  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [stackType, categories]);


  return <Chart key={key} options={options} series={series} type="bar" height={height} />;
};

export default StackedBarsChart;